import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const TakePhoto = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M2.077 9.179a3.445 3.445 0 0 1 1.052-2.04 3.508 3.508 0 0 1 2.108-.94h.813c.45-.034.877-.206 1.223-.493.346-.287.592-.674.704-1.106.108-.424.345-.804.679-1.09A2.168 2.168 0 0 1 9.843 3h4.314c.44.046.854.224 1.187.51.334.286.571.666.68 1.09.111.432.357.819.703 1.106.346.287.773.46 1.223.493h.813c.79.067 1.534.399 2.108.94.575.542.946 1.262 1.052 2.04.159 2.515.072 5.04-.26 7.54a4.09 4.09 0 0 1-1.177 2.114 4.16 4.16 0 0 1-2.175 1.094 58.287 58.287 0 0 1-12.622 0 4.16 4.16 0 0 1-2.175-1.093 4.091 4.091 0 0 1-1.176-2.116 38.701 38.701 0 0 1-.261-7.54Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Path
      d="M11.995 9.24a3.63 3.63 0 0 1 2.037.627 3.705 3.705 0 0 1 1.35 1.667c.277.679.35 1.426.208 2.146a3.732 3.732 0 0 1-1.003 1.903 3.65 3.65 0 0 1-1.877 1.016 3.619 3.619 0 0 1-2.117-.211 3.677 3.677 0 0 1-1.645-1.368 3.752 3.752 0 0 1-.618-2.064 4.176 4.176 0 0 1 1.18-2.52 4.074 4.074 0 0 1 2.485-1.196Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Path
      d="M18.026 8.533a1.1 1.1 0 1 1-1.1 1.09 1.221 1.221 0 0 1 1.1-1.09Z"
      fill="transparent"
    />
  </Icon>
);

export default TakePhoto;
